var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApprovedStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gfp93nvz5a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1EB758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1EB758"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#gfp93nvz5a)",
    fillRule: "nonzero",
    transform: "translate(-1041 -505)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.28C4.294 1.28 1.28 4.295 1.28 8c0 3.705 3.015 6.72 6.72 6.72 3.705 0 6.72-3.015 6.72-6.72 0-3.705-3.015-6.72-6.72-6.72zm3.484 3.709c.35.25.449.72.243 1.085l-.049.077-3.345 4.682c-.044.06-.095.111-.15.155l-.067.048-.062.036-.093.04-.076.026-.07.015-.093.012-.062.002-.073-.004-.09-.014-.08-.02-.087-.033-.059-.029-.05-.029L7.168 11 4.5 9c-.368-.276-.443-.798-.167-1.167.258-.343.73-.431 1.091-.217l.076.05 1.984 1.489 2.838-3.973c.267-.374.788-.461 1.162-.193z",
    transform: "translate(99 106) translate(352 167) translate(0 200) translate(580 25) translate(10 7)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedStatus);
export default __webpack_public_path__ + "static/media/approved-status.e256b0a24dcf4f97af0d1c169f55922f.svg";
export { ForwardRef as ReactComponent };